import { useEffect, useState } from 'react';
import api from '../../services/api';
import AdminLayout from '../../layouts/AdminLayout';

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({ action: '', entity_type: '' });

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ page, limit: 50, ...filters });
    api.get(`/admin/audit-logs?${params}`).then((r) => {
      setLogs(r.data.data);
      setPagination(r.data.pagination);
      setLoading(false);
    });
  }, [page, filters]);

  const ACTION_COLORS = {
    'auth.login':        'bg-blue-100 text-blue-700',
    'worker.approve':    'bg-green-100 text-green-700',
    'worker.reject':     'bg-red-100 text-red-700',
    'payment.verify':    'bg-purple-100 text-purple-700',
    'requirement.create':'bg-brand-100 text-brand-700',
  };

  return (
    <AdminLayout>
      <div className="space-y-5">
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-bold text-gray-900">Audit Logs</h1>
          <span className="text-sm text-gray-500">{pagination.total?.toLocaleString()} entries</span>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-4 flex flex-col sm:flex-row gap-3">
          <input placeholder="Filter by action (e.g. worker.)" value={filters.action}
            onChange={(e) => { setFilters((p) => ({ ...p, action: e.target.value })); setPage(1); }}
            className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-brand-500 focus:outline-none" />
          <select value={filters.entity_type}
            onChange={(e) => { setFilters((p) => ({ ...p, entity_type: e.target.value })); setPage(1); }}
            className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-brand-500 focus:outline-none">
            <option value="">All Entities</option>
            <option value="worker_profiles">Workers</option>
            <option value="employer_profiles">Employers</option>
            <option value="requirements">Requirements</option>
            <option value="payments">Payments</option>
            <option value="users">Users</option>
          </select>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                {['Time', 'Actor', 'Action', 'Entity', 'IP'].map((h) => (
                  <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading ? (
                <tr><td colSpan={5} className="py-8 text-center text-gray-400">Loading...</td></tr>
              ) : logs.map((log) => (
                <tr key={log.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-xs text-gray-500 font-mono whitespace-nowrap">
                    {new Date(log.created_at).toLocaleString('en-IN')}
                  </td>
                  <td className="px-4 py-3 text-gray-600">{log.mobile || <span className="text-gray-300">system</span>}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${ACTION_COLORS[log.action] || 'bg-gray-100 text-gray-600'}`}>
                      {log.action}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-500">
                    {log.entity_type && `${log.entity_type} #${log.entity_id}`}
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-400 font-mono">{log.ip_address}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          {pagination.totalPages > 1 && (
            <div className="border-t border-gray-200 px-4 py-3 flex items-center justify-between text-sm">
              <span className="text-gray-500">Page {pagination.page} of {pagination.totalPages}</span>
              <div className="flex gap-2">
                {pagination.hasPrev && <button onClick={() => setPage(p => p - 1)} className="px-3 py-1.5 border rounded-lg text-sm hover:bg-gray-50">← Prev</button>}
                {pagination.hasNext && <button onClick={() => setPage(p => p + 1)} className="px-3 py-1.5 border rounded-lg text-sm hover:bg-gray-50">Next →</button>}
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
